import {Action} from "../../../action/action";
import type DetailsState from "..";
import { Package } from "@raskrask-dk/raskrask-utils";


export const SET_SPECIALNEEDS = "SET_SPECIALNEEDS";

export class SetSpecialNeeds extends Action<typeof SET_SPECIALNEEDS, true> {
  readonly type = SET_SPECIALNEEDS;
  protected state: DetailsState;

  constructor(state: DetailsState, specialNeeds?: true | undefined) {
    super(state, specialNeeds);
    this.state = state;
  }
  /**
   * Business logic:
   * Only for products which isnt of type Package is this action doable.
   * IF customerType = "Company" this action should be unavailable
   * @returns
   */
  public isDoable(): boolean {
    const {product, customerType, basisType} = this.state;
    const isBasisTypeMassage = basisType?.id === 1;
    const isProductAPackage = product instanceof Package;
    const isPrivateCustomer = customerType === "Private";
    return !isProductAPackage && isPrivateCustomer && isBasisTypeMassage;
  }
  public isValid(): boolean {
    return this.isDoable();
  }
}
